import React, { Fragment } from 'react'
import { RegulationIuppComponent } from 'loyal-react'
import Helmet from 'react-helmet'

const RegulationIupp = () => (
  <Fragment>
    <Helmet>
      <title>{`Regulamentos - ${process.env.REACT_APP_TITLE || ''}`}</title>
    </Helmet>
    <div className='container-fluid bg-color-ui-4'>
      <div className='container mt-5 pb-5'>
        <div className='row py-5 pb-5'>
          <div className='col-12 px-1 py-3 px-md-2'>
            <div className='row  mx mx-md-0'>
              <RegulationIuppComponent />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Fragment>
)

export default RegulationIupp



// WEBPACK FOOTER //
// ./src/features/Regulation/RegulationIupp.js